<script setup lang="ts">
const { t } = useI18n();

const open = useState("activity:leaveConfirmOpen", () => false);
const pendingRoute = useState<string | null>("activity:leaveConfirmRoute", () => null);
const bypass = useState("activity:leaveConfirmBypass", () => false);

const confirm = async () => {
  open.value = false;
  const route = pendingRoute.value;
  pendingRoute.value = null;
  if (route) {
    bypass.value = true;
    await navigateTo(route);
  }
};

const cancel = () => {
  open.value = false;
  pendingRoute.value = null;
};

const buttons = computed(() => [
  { label: t("activity.new.leave.confirm"), onClick: confirm },
  { label: t("activity.new.leave.cancel"), onClick: cancel },
]);
</script>

<template>
  <AppDialog
    v-model:open="open"
    :title="t('activity.new.leave.title')"
    :description="t('activity.new.leave.description')"
    :buttons="buttons"
  />
</template>
